export const buildOrderDetailsUpdatingStates = ({ uiState, actions, components, ctx }) => {
  const {
    onCloseConflict,
    onCloseSkipped,
    setShowCancelModal,
    setShowInputs,
    setInputs,
    setShowAddItemModal,
    setAddItemSearchQuery,
    addItensToOrder,
    setShowNewItemsValidationModal,
    setShowUnsavedItemsModal
  } = actions;

  const { 
    t,
    searchQuery,
    supplierId,
    orderItemsToUse,
    unsavedItems
  } = ctx;

  const {
    qtyOfItemsToRemove,
    qtyOfItensToUpdate,
    conflictProducts,
    skippedItemsInfo,
    isPatchingOrder,
    showConflictModal,
    showSkippedItemsModal,
    showCancelModal,
    patchOrdersError,
    showAddItemModal,
    showNewItemsValidationModal,
    invalidNewItems,
    showUnsavedWarningModal
  } = uiState;

  const {
    ModalToControlUpdateAndRemovalOperations,
    ModalToCancelEditModeOnItem,
    ModalToAddItems,
    ModalToValidateNewItems,
    ModalToWarnUserThatExistsUnsavedItems
  } = components;

  const defineLabel = () => {
    if (qtyOfItemsToRemove > 0 && qtyOfItensToUpdate > 0) return t("updateAndRemoveMessage");
    if (qtyOfItemsToRemove > 0) return t("removingItem");
    if (qtyOfItensToUpdate > 0) return t("updatingMessage");
    return "";
  };

  const defineDynamicLabels = () => {
    if (qtyOfItemsToRemove > 0 && qtyOfItensToUpdate > 0) {
      return [t("updatingItems"), t("updatingItems_plural"), t("removingItem_item"), t("removingItem_plural")];
    }
    if (qtyOfItemsToRemove > 0) return [t("removingItem_item"), t("removingItem_plural")];
    if (qtyOfItensToUpdate > 0) return [t("updatingItems"), t("updatingItems_plural")];
    return ["", ""];
  };

  const needMoreLines = qtyOfItemsToRemove && qtyOfItensToUpdate;

  return {
    modalState: {
      patching: isPatchingOrder && !patchOrdersError,
      conflict: showConflictModal,
      skippedItems: showSkippedItemsModal && !!skippedItemsInfo,
      cancelEditMode: showCancelModal,
      addMoreItens: showAddItemModal,
      newItemsValidation: showNewItemsValidationModal,
      unsavedItemsWarning: showUnsavedWarningModal,
    },
    components: {
      patching: ModalToControlUpdateAndRemovalOperations,
      conflict: ModalToControlUpdateAndRemovalOperations,
      skippedItems: ModalToControlUpdateAndRemovalOperations,
      cancelEditMode: ModalToCancelEditModeOnItem,
      addMoreItens: ModalToAddItems,
      newItemsValidation: ModalToValidateNewItems,
      unsavedItemsWarning: ModalToWarnUserThatExistsUnsavedItems
    },
    propsMap: {
      patching: {
        ctx: {
          count: qtyOfItemsToRemove + qtyOfItensToUpdate,
          numberOfItemsToUpdate: qtyOfItensToUpdate,
          numberOfItensToRemove: qtyOfItemsToRemove,
          label: {
            primaryMessage: defineLabel(),
            dynamicMessagesArr: defineDynamicLabels(),
          },
        },
        uiState: {
          isOpen: isPatchingOrder,
          needMoreLines: needMoreLines,
          numberOfAditionalLines: needMoreLines ? 1 : 0,
        },
      },
      conflict: {
        actions: { onClose: onCloseConflict },
        ctx: {
          count: conflictProducts?.length ?? 0,
          label: {
            primaryMessage: t("attention"),
            dynamicMessagesArr: [t("conflictingOperationMessage")],
          },
        },
        uiState: {
          isOpen: showConflictModal,
          isWarningModal: true,
          needMoreLines: false,
          numberOfAditionalLines: 0,
        },
      },
      skippedItems: {
        actions: { onClose: onCloseSkipped },
        ctx: {
          count: skippedItemsInfo?.skippedCount ?? 0,
          label: {
            primaryMessage:
              skippedItemsInfo?.updatedCount > 0
                ? `${skippedItemsInfo.updatedCount} ${skippedItemsInfo.updatedCount === 1 ? "item atualizado" : "itens atualizados"} com sucesso`
                : t("attention"),
            dynamicMessagesArr: [
              `${skippedItemsInfo?.skippedCount} ${skippedItemsInfo?.skippedCount === 1 ? "item não pôde" : "itens não puderam"} ser ${skippedItemsInfo?.skippedCount === 1 ? "atualizado" : "atualizados"} (já ${skippedItemsInfo?.skippedCount === 1 ? "foi removido" : "foram removidos"}):`,
              ...(skippedItemsInfo?.skippedDetails?.map(item => `• ${item.productName}`) ?? []),
            ],
          },
        },
        uiState: {
          isOpen: showSkippedItemsModal,
          isWarningModal: true,
          needMoreLines: false,
          numberOfAditionalLines: 0,
        },
      },
      cancelEditMode: {
        t,
        setShowInputs,
        setInputs,
        setShowCancelModal,
      },
      addMoreItens: {
        actions: {
          onClose: () => {
            setShowAddItemModal(false);
            setAddItemSearchQuery("");
          },
          addItensToOrder: addItensToOrder,
          onSearchChange: setAddItemSearchQuery,
        },
        ctx: {
          searchQuery: searchQuery,
          supplierId: supplierId,
          orderItemsToUse: orderItemsToUse
        },
        uiState: {
          isOpen: showAddItemModal,
        },
      },
      newItemsValidation: {
        actions: { onClose: () => setShowNewItemsValidationModal(false) },
        ctx: { invalidItems: invalidNewItems },
        uiState: { isOpen: showNewItemsValidationModal },
      },
      unsavedItemsWarning: {
        actions: {
          setShowUnsavedItemsModal: setShowUnsavedItemsModal
        },
        ctx: {
          unsavedItems: unsavedItems
        },
        uiState: {
          showUnsavedWarningModal: showUnsavedWarningModal
        }
      } 
    },
  };
};